module.exports = __webpack_public_path__ + "static/img/bg-btn-post@2x.e171bd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/bg-btn-post@2x.png
// module id = 924
// module chunks = 0